import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import ApplicationTag from './ApplicationTag';

const createProps = () => ({});

let props;
let wrapped: ShallowWrapper;

describe('Component renders correctly', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<ApplicationTag {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
